export default __webpack_public_path__ + "static/media/dropFront3.7d04cd8d.png";